import { css } from '@emotion/css';
import { Remirror } from '@remirror/react';
import { getThemeVar } from 'remirror';

import { IModeEditorProps } from '../types';
import { useWrapperEditor } from '../utils';

import '@remirror/styles/all.css';
import '../styles.css';

export const MarkdownTextEditor: React.FC<IModeEditorProps> = ({
  onChange,
  placeholder
}) => {
  const { markdown, setVisual } = useWrapperEditor();

  return (
    <Remirror
      manager={markdown.manager}
      autoRender="end"
      placeholder={placeholder}
      onChange={({ helpers, state }) => {
        const text = helpers.getText({ state });
        onChange(text);
        setVisual(text);
      }}
      classNames={[
        'flex flex-col h-[260px] w-full rounded-md border border-input bg-white px-3 py-2 text-base placeholder:text-base-mutedForeground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-p-s shadow-none text-base-foreground mt-0 placeholder:text-base-mutedForeground min-h-[350px] max-h-[700px] overflow-auto resize-y',
        css`
          &.ProseMirror {
            padding: 0;

            pre {
              height: 100%;
              padding: ${getThemeVar('space', 3)};
              margin: 0;
              padding: 8px;
              white-space: pre-wrap;
            }
          }
        `
      ]}
    />
  );
};
